const tones = {
  neutral: { background: "var(--surface-sunken)", color: "var(--text-secondary)" },
  brand: { background: "var(--brand-soft)", color: "var(--brand-strong)" },
  accent: { background: "var(--accent-soft)", color: "var(--accent-strong)" },
  success: { background: "var(--success-soft)", color: "var(--sage-700)" },
  warning: { background: "var(--warning-soft)", color: "var(--ember-700)" },
  danger: { background: "var(--danger-soft)", color: "var(--crimson-700)" },
  info: { background: "var(--info-soft)", color: "var(--navy-700)" },
  solid: { background: "var(--ink-900)", color: "var(--sand-75)" },
};

export default function Badge({ children, tone = "neutral", dot = false, style, ...rest }) {
  const t = tones[tone] || tones.neutral;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontFamily: "var(--font-body)",
        fontSize: "var(--text-xs)",
        fontWeight: "var(--weight-semibold)",
        letterSpacing: "var(--tracking-snug)",
        padding: "4px 10px",
        borderRadius: "var(--radius-pill)",
        lineHeight: 1.2,
        ...t,
        ...style,
      }}
      {...rest}
    >
      {dot && <span style={{ width: 6, height: 6, borderRadius: "50%", background: "currentColor" }} />}
      {children}
    </span>
  );
}
